(function () {
  var GIFT_PROPERTY = "_auto_gift";
  var busy = false;

  function routes() {
    var el = document.querySelector("[data-cart-routes]");
    if (el) {
      try {
        return JSON.parse(el.textContent);
      } catch (e) {}
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return {
      cartUrl: root + "cart",
      cartAddUrl: root + "cart/add",
      cartChangeUrl: root + "cart/change"
    };
  }

  function xhr(method, url, body) {
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open(method, url);
      req.withCredentials = true;
      req.setRequestHeader("Accept", "application/json");
      req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      if (body) req.setRequestHeader("Content-Type", "application/json");
      req.onload = function () {
        var json = null;
        try {
          json = JSON.parse(req.responseText);
        } catch (e) {}
        if (req.status >= 200 && req.status < 300) {
          if (json && json.status && json.status !== 200) {
            reject(new Error(json.description || json.message || "Request failed"));
            return;
          }
          resolve(json);
          return;
        }
        reject(new Error((json && (json.description || json.message)) || "HTTP " + req.status));
      };
      req.onerror = function () {
        reject(new Error("Network error"));
      };
      req.send(body ? JSON.stringify(body) : null);
    });
  }

  function getCart() {
    return xhr("GET", routes().cartUrl + ".js");
  }

  function configuredVariantIds() {
    var ids = {};
    var cfg = document.querySelector("[data-auto-gift-config]");
    if (cfg) {
      try {
        var parsed = JSON.parse(cfg.textContent);
        (parsed.gifts || []).forEach(function (g) {
          ids[Number(g.variantId)] = g;
        });
      } catch (e) {}
    }
    document.querySelectorAll("[data-auto-gift-option]").forEach(function (btn) {
      var id = Number(btn.dataset.variantId);
      if (id && !ids[id]) {
        ids[id] = {
          variantId: id,
          tier: Number(btn.dataset.tier) || 1
        };
      }
    });
    return ids;
  }

  function isGiftItem(item, giftMap) {
    if (!item) return false;
    if (item.properties && item.properties[GIFT_PROPERTY] === "true") return true;
    return Boolean(giftMap[Number(item.variant_id)]);
  }

  function giftLines(cart, giftMap) {
    var lines = [];
    (cart.items || []).forEach(function (item, i) {
      if (!isGiftItem(item, giftMap)) return;
      lines.push({
        key: item.key,
        variantId: Number(item.variant_id),
        line: i + 1
      });
    });
    return lines;
  }

  function paidTotal(cart, giftMap) {
    return (cart.items || []).reduce(function (sum, item) {
      return isGiftItem(item, giftMap) ? sum : sum + item.final_line_price;
    }, 0);
  }

  function paidCount(cart, giftMap) {
    return (cart.items || []).filter(function (item) {
      return !isGiftItem(item, giftMap);
    }).length;
  }

  function thresholdsFromDom() {
    var picker = document.querySelector("[data-auto-gift-picker]");
    var cfg = document.querySelector("[data-auto-gift-config]");
    var t1 = 10000;
    var t2 = 15000;
    if (picker) {
      t1 = Number(picker.dataset.threshold1) || t1;
      t2 = Number(picker.dataset.threshold2) || t2;
    }
    if (cfg) {
      try {
        var parsed = JSON.parse(cfg.textContent);
        if (parsed.threshold1) t1 = Number(parsed.threshold1);
        if (parsed.threshold2) t2 = Number(parsed.threshold2);
      } catch (e) {}
    }
    return { t1: t1, t2: t2 };
  }

  function unlockedTier(total) {
    var t = thresholdsFromDom();
    if (total > t.t2) return 2;
    if (total > t.t1) return 1;
    return 0;
  }

  function removeKey(key) {
    return xhr("POST", routes().cartChangeUrl + ".js", { id: key, quantity: 0 });
  }

  function addGift(variantId) {
    return xhr("POST", routes().cartAddUrl + ".js", {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            _auto_gift: "true",
            _stl_item: "true",
            _stl_bundle: "stl-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8)
          }
        }
      ]
    });
  }

  function removeAll(lines) {
    return lines.reduce(function (p, line) {
      return p.then(function () {
        return removeKey(line.key);
      });
    }, Promise.resolve());
  }

  function setPreview(btn) {
    if (!btn) return;
    var picker = btn.closest("[data-auto-gift-picker]");
    if (!picker || !btn.dataset.image) return;
    var img = picker.querySelector("[data-auto-gift-preview]");
    if (img) {
      img.src = btn.dataset.image;
      if (btn.dataset.label) img.alt = btn.dataset.label;
    }
  }

  function markUI(variantId) {
    document.querySelectorAll("[data-auto-gift-option]").forEach(function (btn) {
      var selected = Number(btn.dataset.variantId) === Number(variantId);
      btn.classList.toggle("is-selected", selected);
    });
    document.querySelectorAll("[data-auto-gift-title]").forEach(function (title) {
      var n = variantId ? 1 : 0;
      title.textContent = String(title.textContent || "CHOOSE YOUR GIFT (0/1)").replace(
        /\(\d+\/\d+\)/,
        "(" + n + "/1)"
      );
    });
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent("auto-gift:changed", { detail: { selected: true } }));
    var cnl = document.querySelector("carrito-new-lateral");
    if (cnl && typeof cnl.refresh === "function") {
      return cnl.refresh();
    }
    return Promise.resolve();
  }

  function updateCount(n) {
    var el = document.querySelector("[data-cart-count]");
    var bubble = document.querySelector("[data-cart-count-bubble]");
    if (el) el.textContent = n;
    if (bubble) bubble.classList.toggle("hide", n < 1);
  }

  function updateLockState(cart, giftMap) {
    var total = paidTotal(cart, giftMap);
    var tier = unlockedTier(total);
    document.querySelectorAll("[data-auto-gift-picker]").forEach(function (picker) {
      picker.dataset.unlockedTier = String(tier);
      var hint = picker.querySelector("[data-auto-gift-hint]");
      if (hint) hint.hidden = tier >= 2 || tier < 1;
      picker.querySelectorAll("[data-auto-gift-option]").forEach(function (btn) {
        var btnTier = Number(btn.dataset.tier) || 1;
        var locked = btnTier > tier;
        btn.disabled = locked;
        btn.classList.toggle("is-locked", locked);
        btn.setAttribute("aria-disabled", locked ? "true" : "false");
        var lock = btn.querySelector(".auto-gift-picker__lock");
        if (locked && !lock) {
          lock = document.createElement("span");
          lock.className = "auto-gift-picker__lock";
          lock.textContent = "FROM 150€";
          btn.appendChild(lock);
        } else if (!locked && lock) {
          lock.remove();
        }
      });
    });
  }

  // Main entry used by onclick on buttons + wired handlers
  function pickGift(btnOrId) {
    var btn =
      btnOrId && btnOrId.dataset
        ? btnOrId
        : document.querySelector('[data-auto-gift-option][data-variant-id="' + btnOrId + '"]');

    if (!btn || btn.disabled || btn.classList.contains("is-locked")) return false;
    if (busy) return false;

    var variantId = Number(btn.dataset.variantId);
    if (!variantId) return false;

    busy = true;
    window.__autoGiftBusy = true;
    btn.classList.add("is-loading");
    setPreview(btn);
    markUI(variantId);

    var giftMap = configuredVariantIds();

    getCart()
      .then(function (cart) {
        var total = paidTotal(cart, giftMap);
        var paid = paidCount(cart, giftMap);
        var tier = unlockedTier(total);
        var btnTier = Number(btn.dataset.tier) || 1;

        if (paid === 0 || btnTier > tier) {
          throw new Error("Gift not available for current cart");
        }

        var lines = giftLines(cart, giftMap);
        var already = lines.some(function (l) {
          return l.variantId === variantId;
        });

        var chain = removeAll(lines);

        if (already) {
          return chain.then(getCart).then(function (updated) {
            markUI(0);
            updateCount(updated.item_count);
            updateLockState(updated, giftMap);
            return updated;
          });
        }

        return chain
          .then(function () {
            return addGift(variantId);
          })
          .then(getCart)
          .then(function (updated) {
            markUI(variantId);
            updateCount(updated.item_count);
            updateLockState(updated, giftMap);
            return updated;
          });
      })
      .then(function () {
        return refreshCartUI();
      })
      .catch(function (err) {
        console.error("[auto-gift]", err);
        alert(err && err.message ? err.message : "Could not select gift");
        markUI(0);
      })
      .finally(function () {
        busy = false;
        window.__autoGiftBusy = false;
        document.querySelectorAll(".auto-gift-picker__btn.is-loading").forEach(function (el) {
          el.classList.remove("is-loading");
        });
        // Re-wire after refresh in case DOM was replaced mid-flight
        wireButtons(document);
      });

    return false;
  }

  function syncCart() {
    if (busy) return Promise.resolve({ changed: false });
    busy = true;
    window.__autoGiftBusy = true;

    var giftMap = configuredVariantIds();

    return getCart()
      .then(function (cart) {
        var lines = giftLines(cart, giftMap);
        var total = paidTotal(cart, giftMap);
        var paid = paidCount(cart, giftMap);
        var tier = unlockedTier(total);

        updateLockState(cart, giftMap);

        var selected = lines[0] ? lines[0].variantId : 0;
        markUI(selected);
        updateCount(cart.item_count);

        // Gift alone or under threshold → remove gifts
        if (paid === 0 || total <= 0 || tier === 0) {
          if (!lines.length) return { cart: cart, changed: false };
          return removeAll(lines)
            .then(getCart)
            .then(function (updated) {
              markUI(0);
              updateCount(updated.item_count);
              updateLockState(updated, giftMap);
              return { cart: updated, changed: true };
            });
        }

        var invalid = lines.filter(function (line) {
          var g = giftMap[line.variantId];
          var gTier = g ? Number(g.tier) || 1 : 1;
          return gTier > tier;
        });
        var extras = lines.filter(function (line) {
          var g = giftMap[line.variantId];
          var gTier = g ? Number(g.tier) || 1 : 1;
          return gTier <= tier;
        }).slice(1);

        var toRemove = invalid.concat(extras);
        if (!toRemove.length) return { cart: cart, changed: false };

        return removeAll(toRemove)
          .then(getCart)
          .then(function (updated) {
            var keep = giftLines(updated, giftMap)[0];
            markUI(keep ? keep.variantId : 0);
            updateCount(updated.item_count);
            updateLockState(updated, giftMap);
            return { cart: updated, changed: true };
          });
      })
      .then(function (result) {
        if (result && result.changed) {
          document.dispatchEvent(new CustomEvent("auto-gift:changed", { detail: result }));
        }
        return result || { changed: false };
      })
      .catch(function (err) {
        console.error("[auto-gift] sync", err);
        return { changed: false };
      })
      .finally(function () {
        busy = false;
        window.__autoGiftBusy = false;
      });
  }

  function wireButtons(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-auto-gift-option]").forEach(function (btn) {
      if (btn.__giftWired) return;
      btn.__giftWired = true;
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        pickGift(btn);
      });
      btn.addEventListener("mouseenter", function () {
        if (!btn.disabled) setPreview(btn);
      });
    });
  }

  // Global API — used by liquid onclick and side cart
  window.__pickGift = pickGift;
  window.AutoGift = {
    selectGift: function (idOrBtn) {
      return pickGift(idOrBtn);
    },
    runSync: syncCart,
    afterCartChange: syncCart,
    scheduleSync: function () {
      return syncCart();
    },
    bindListeners: function () {
      wireButtons(document);
    },
    wireButtons: wireButtons,
    updatePickerUI: function () {
      return getCart().then(function (cart) {
        updateLockState(cart, configuredVariantIds());
        var lines = giftLines(cart, configuredVariantIds());
        markUI(lines[0] ? lines[0].variantId : 0);
      });
    },
    isBusy: function () {
      return busy;
    }
  };

  // Capture-phase backup removed — onclick + wireButtons are enough.
  // stopPropagation in capture was blocking liquid onclick.

  function boot() {
    wireButtons(document);
    // Flush clicks that happened before this file finished loading
    var queue = window.__pickGiftQueue || [];
    window.__pickGiftQueue = [];
    queue.forEach(function (btn) {
      pickGift(btn);
    });
    syncCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
